import {
  CONSENT_CATEGORY_ANALYTICS,
  CONSENT_CATEGORY_MARKETING,
  ConsentCategoryInfo,
  ConsentPreferences
} from "./types";

import { hasPrivacySignal } from "./utils/hasPrivacySignal";

export const CONSENT_STORAGE_KEY = "cookie-consent";

export const DEFAULT_CONSENT_PREFERENCES: ConsentPreferences = {
  [CONSENT_CATEGORY_MARKETING]: !hasPrivacySignal(),
  [CONSENT_CATEGORY_ANALYTICS]: !hasPrivacySignal()
};

export const CONSENT_CATEGORIES: readonly ConsentCategoryInfo[] = [
  {
    alwaysOn: true,
    defaultValue: true,
    description:
      "Required for authentication, security, and core app functionality.",
    id: CONSENT_CATEGORY_MARKETING,
    label: "Essential (always on)"
  },
  {
    alwaysOn: false,
    defaultValue: true,
    description:
      "Helps us understand how people use Wingspan so we can improve the experience.",
    id: CONSENT_CATEGORY_ANALYTICS,
    label: "Analytics & non-essential (optional)"
  }
];
